import useGlobalStore from '@/store/useGlobalStore'

type Props = React.HTMLAttributes<HTMLDivElement> & {
  children: React.ReactNode
}

export const HideForCustomer = ({ children, ...props }: Props) => {
  const {
    user: { customerType },
  } = useGlobalStore()

  if (customerType === 'Customer') return null

  return <div {...props}>{children}</div>
}
